/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Box from 'core/ui/Box';
import Paper from 'core/ui/Paper';
import Typography, { fontStyle } from 'core/ui/Typography';
import { secondary } from 'core/ui/Colors';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@material-ui/core';
import StoreProducts from 'components/Store/Products';
import TablePlans from 'components/Channel/Manage/Tabs/Memberships/TablePlans';
import { useSelector } from 'react-redux';
import { channelsSelectors } from 'modules/channels';

const FormSendStreamLinks = () => {
  const { t } = useTranslation();
  const [openModalStore, setOpenModalStore] = useState(false);
  const [openModalMembership, setOpenModalMembership] = useState(false);
  const boxStyle = {
    padding: 3,
    border: `0.2px solid ${secondary}`,
  };

  const channel = useSelector((state) => channelsSelectors.getChannel(state));

  const openMembershipChoose = () => {
    setOpenModalMembership(true);
  };

  return (
    <div>
      <Typography mt={3} style={fontStyle.label}>
        StreamFit Links
      </Typography>
      <Box display="flex" flexWrap="wrap">
        <>
          <Paper
            m={1}
            style={boxStyle}
            className="paper-rounded link-hover"
            onClick={() => openMembershipChoose()}
          >
            <Typography color="secondary" variant="caption">
              {t('channel.membershipLink')}
            </Typography>

            {openModalMembership && (
              <Dialog
                open={openModalMembership}
                maxWidth="md"
                fullWidth
                onClose={() => setOpenModalMembership(false)}
              >
                <Box p={3}>
                  <TablePlans channel={channel} membershipPlans={channel?.membershipAllPlans} />
                </Box>
              </Dialog>
            )}
          </Paper>
          <Paper
            m={1}
            style={boxStyle}
            className="paper-rounded link-hover"
            onClick={() => setOpenModalStore(true)}
          >
            <Typography color="secondary" variant="caption">
              {t('channel.storeProductLink')}
            </Typography>

            {openModalStore && (
              <Dialog
                open={openModalStore}
                maxWidth="lg"
                fullWidth
                onClose={() => setOpenModalStore(false)}
              >
                <Box p={3}>
                  {!!channel?.id && (
                    <StoreProducts
                      channelId={channel?.id}
                      ownerableId={channel?.id}
                      ownerableType="Channel"
                      currency={channel?.currency}
                      channelsTaxes={channel?.channelsTaxes}
                      copyLink
                    />
                  )}
                </Box>
              </Dialog>
            )}
          </Paper>
        </>
      </Box>
    </div>
  );
};

export default FormSendStreamLinks;
